(() => {
  const money = (cents) => {
    const currency = window.LEMENTS?.currency || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((cents || 0) / 100);
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }));
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.showModal();
    document.body.classList.add('drawer-open');
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.close();
    document.body.classList.remove('drawer-open');
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  drawer?.addEventListener('click', (event) => { if (event.target === drawer) closeDrawer(); });

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-subtotal]').forEach((node) => { node.textContent = money(cart.total_price); });
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<p class="prototype-note">Your cart is empty.</p>';
      return;
    }
    items.innerHTML = cart.items.map((item) => {
      const image = item.featured_image?.url ? `<img src="${escapeHtml(item.featured_image.url)}" alt="${escapeHtml(item.product_title)}" width="80" height="80">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `<article class="drawer-item">${image}<div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(variant)} × ${item.quantity}</p><p>${money(item.final_line_price)}</p></div></article>`;
    }).join('');
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-variants]');
    if (!json) return;
    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }
    const optionGroups = [...root.querySelectorAll('[data-option-group]')];
    const selected = optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue || group.querySelector('[data-option-button]')?.dataset.optionValue);
    const variantInput = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');

    const update = () => {
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (location.pathname.includes('/products/')) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.optionIndex);
      selected[index] = button.dataset.optionValue;
      const group = button.closest('[data-option-group]');
      group.querySelectorAll('[data-option-button]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      update();
    }));
    update();
  });

  if (window.LEMENTS?.cartDrawer) {
    document.querySelectorAll('.product-form').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const root = form.closest('[data-product-root]');
      const error = root?.querySelector('[data-product-error]');
      const submit = form.querySelector('[data-add-to-cart]');
      try {
        if (submit) submit.disabled = true;
        const response = await fetch(window.LEMENTS.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this product.');
        const cart = await fetch(window.LEMENTS.routes.cartJson, { headers: { Accept: 'application/json' } }).then((result) => result.json());
        renderCart(cart);
        if (error) error.hidden = true;
        openDrawer();
      } catch (exception) {
        if (error) { error.textContent = exception.message; error.hidden = false; }
      } finally {
        if (submit) submit.disabled = false;
      }
    }));
  }

  const body = document.body;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionEnabled = body.dataset.motionEnabled !== 'false' && !reducedMotion;
  const pointerEnabled = body.dataset.pointerEnabled !== 'false' && motionEnabled && window.matchMedia('(pointer: fine)').matches;
  const motionIntensity = Number.parseFloat(getComputedStyle(body).getPropertyValue('--motion-intensity')) || 0.6;
  const selectWithin = (scope, selector) => [
    ...(scope.matches?.(selector) ? [scope] : []),
    ...scope.querySelectorAll(selector)
  ];

  const pageProgress = document.querySelector('[data-scroll-progress]');
  const siteHeader = document.querySelector('[data-site-header]');
  let scrollFrame = 0;
  const updatePageState = () => {
    const scrollRange = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    document.documentElement.style.setProperty('--page-progress', String(Math.min(window.scrollY / scrollRange, 1)));
    siteHeader?.classList.toggle('is-scrolled', window.scrollY > 24);
    scrollFrame = 0;
  };
  const requestPageState = () => {
    if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updatePageState);
  };
  if (pageProgress || siteHeader) {
    updatePageState();
    window.addEventListener('scroll', requestPageState, { passive: true });
    window.addEventListener('resize', requestPageState, { passive: true });
  }

  const revealObserver = motionEnabled && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 })
    : null;

  const initReveals = (scope) => {
    selectWithin(scope, '[data-reveal]').forEach((node) => {
      if (node.dataset.revealReady) return;
      node.dataset.revealReady = 'true';
      if (revealObserver) revealObserver.observe(node);
      else node.classList.add('is-visible');
    });
  };

  const initPointerSurfaces = (scope) => {
    selectWithin(scope, '[data-pointer-surface]').forEach((surface) => {
      if (surface.dataset.pointerReady) return;
      surface.dataset.pointerReady = 'true';
      if (!pointerEnabled) return;

      let pointerFrame = 0;
      let nextX = 0.5;
      let nextY = 0.5;
      let pointerInside = false;
      const renderPointer = () => {
        const xOffset = (nextX - 0.5) * 26 * motionIntensity;
        const yOffset = (nextY - 0.5) * 20 * motionIntensity;
        surface.style.setProperty('--pointer-x', `${nextX * 100}%`);
        surface.style.setProperty('--pointer-y', `${nextY * 100}%`);
        surface.style.setProperty('--parallax-x', `${xOffset}px`);
        surface.style.setProperty('--parallax-y', `${yOffset}px`);
        surface.style.setProperty('--parallax-soft-x', `${xOffset * -0.15}px`);
        surface.style.setProperty('--parallax-soft-y', `${yOffset * -0.15}px`);
        surface.style.setProperty('--tilt-x', `${(nextX - 0.5) * 3.2 * motionIntensity}deg`);
        surface.style.setProperty('--tilt-y', `${(0.5 - nextY) * 3.2 * motionIntensity}deg`);
        surface.style.setProperty('--pointer-opacity', pointerInside ? '1' : '0');
        pointerFrame = 0;
      };
      surface.addEventListener('pointermove', (event) => {
        pointerInside = true;
        const bounds = surface.getBoundingClientRect();
        nextX = Math.min(Math.max((event.clientX - bounds.left) / bounds.width, 0), 1);
        nextY = Math.min(Math.max((event.clientY - bounds.top) / bounds.height, 0), 1);
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(renderPointer);
      }, { passive: true });
      surface.addEventListener('pointerleave', () => {
        pointerInside = false;
        nextX = 0.5;
        nextY = 0.5;
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(renderPointer);
      });
    });
  };

  const initNarratives = (scope) => {
    selectWithin(scope, '[data-visual-narrative]').forEach((section) => {
      if (section.dataset.narrativeReady) return;
      section.dataset.narrativeReady = 'true';
      const steps = [...section.querySelectorAll('[data-narrative-step]')];
      const jumpButtons = [...section.querySelectorAll('[data-narrative-jump]')];
      const title = section.querySelector('[data-narrative-stage-title]');
      const caption = section.querySelector('[data-narrative-stage-caption]');
      const counter = section.querySelector('[data-narrative-counter]');
      if (!steps.length) return;

      let activeIndex = -1;
      const setActiveStep = (index) => {
        const boundedIndex = Math.min(Math.max(index, 0), steps.length - 1);
        if (boundedIndex === activeIndex) return;
        activeIndex = boundedIndex;
        const activeStep = steps[boundedIndex];
        section.dataset.activeStep = String(boundedIndex);
        section.dataset.activePhase = activeStep.dataset.narrativePhase || 'signal';
        section.style.setProperty('--narrative-progress', String(steps.length > 1 ? boundedIndex / (steps.length - 1) : 1));
        steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === boundedIndex));
        jumpButtons.forEach((button, buttonIndex) => {
          if (buttonIndex === boundedIndex) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        if (title) title.textContent = activeStep.dataset.stageTitle || '';
        if (caption) caption.textContent = activeStep.dataset.stageCaption || '';
        if (counter) counter.textContent = `${String(boundedIndex + 1).padStart(2, '0')} / ${String(steps.length).padStart(2, '0')}`;
      };

      setActiveStep(0);
      const stepObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio);
          if (visible.length) setActiveStep(Number(visible[0].target.dataset.narrativeStep));
        }, { rootMargin: '-30% 0px -45% 0px', threshold: [0.05, 0.2, 0.45, 0.7] })
        : null;
      steps.forEach((step) => stepObserver?.observe(step));
      jumpButtons.forEach((button) => button.addEventListener('click', () => {
        const target = steps[Number(button.dataset.narrativeJump)];
        target?.scrollIntoView({ behavior: motionEnabled ? 'smooth' : 'auto', block: 'center' });
      }));
    });
  };

  const initReleaseGalleries = (scope) => {
    selectWithin(scope, '[data-release-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      const panels = [...gallery.querySelectorAll('[data-release-media]')];
      const buttons = [...gallery.querySelectorAll('[data-release-media-button]')];
      const counter = gallery.querySelector('[data-release-counter]');
      const setActiveMedia = (index) => {
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        buttons.forEach((button, buttonIndex) => button.setAttribute('aria-selected', String(buttonIndex === index)));
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      };
      buttons.forEach((button) => button.addEventListener('click', () => setActiveMedia(Number(button.dataset.releaseMediaButton))));
      setActiveMedia(0);
    });
  };

  const initSpectrumConsoles = (scope) => {
    selectWithin(scope, '[data-spectrum-console]').forEach((consoleNode) => {
      if (consoleNode.dataset.spectrumReady) return;
      consoleNode.dataset.spectrumReady = 'true';
      const cards = [...consoleNode.querySelectorAll('[data-spectrum-card]')];
      const liveLabel = consoleNode.querySelector('[data-spectrum-live]');
      const activate = (card) => {
        cards.forEach((candidate) => {
          const active = candidate === card;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        consoleNode.style.setProperty('--frequency-color', card.dataset.frequencyColor || 'var(--ion)');
        if (liveLabel) liveLabel.textContent = card.dataset.frequencyLabel || '';
      };
      cards.forEach((card) => {
        card.addEventListener('click', () => activate(card));
        card.addEventListener('focus', () => activate(card));
        card.addEventListener('pointerenter', () => activate(card), { passive: true });
      });
      if (cards[0]) activate(cards[0]);
    });
  };

  const initInteractiveExperience = (scope = document) => {
    initReveals(scope);
    initPointerSurfaces(scope);
    initNarratives(scope);
    initReleaseGalleries(scope);
    initSpectrumConsoles(scope);
  };

  initInteractiveExperience();
  body.classList.add('interactions-ready');
  document.addEventListener('shopify:section:load', (event) => initInteractiveExperience(event.target));
})();
